<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <a
        class="btn btn-primary"
        *vdrIfPermissions="['CreateBaseProduct']"
        [routerLink]="['./', 'create']"
      >
        <clr-icon shape="plus"></clr-icon>
        Criar Produto Base
      </a>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  id="baseProduct"
  [activeIndex]="activeIndex | async"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    searchTermPlaceholder="Filtre por nome"
  ></vdr-dt2-search>
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-baseProduct="item">{{ baseProduct.id }}</ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [sort]="sorts.get('name')"
    [heading]="'common.name' | translate"
  >
    <ng-template let-baseProduct="item">
      <a
        class="button-ghost"
        [routerLink]="['./', baseProduct.id]"
      >
        <span>{{ baseProduct.name }}</span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [sort]="sorts.get('size')"
    [heading]="'common.size' | translate"
  >
    <ng-template let-baseProduct="item">
      <span>{{ baseProduct.size }}</span>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [sort]="sorts.get('weight')"
    [heading]="'common.weight' | translate"
  >
    <ng-template let-baseProduct="item">
      <span>{{ baseProduct.weight }}</span>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [sort]="sorts.get('price')"
    [heading]="'common.price' | translate"
  >
    <ng-template let-baseProduct="item">
      <span>{{ baseProduct.price }}</span>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column [heading]="'catalog.variant' | translate">
    <ng-template let-baseProduct="item">
      <ng-template [ngIf]="baseProduct.productVariants?.length > 0">
        <span>
          {{
            'catalog.variant-count'
              | translate: { count: baseProduct.productVariants.length }
          }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </ng-template>
      <ng-template [ngIf]="baseProduct.productVariants?.length == 0">
        <span>0 {{ 'catalog.variants' | translate }}</span>
      </ng-template>
      {{ baseProduct.productVariants.lenght }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [sort]="sorts.get('createdAt')"
    [heading]="'common.created-at' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-baseProduct="item">
      {{ baseProduct.createdAt | localeDate: 'short' }}
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
